package com.trevorwiebe.timesheet.core.domain

data class TSResult(
    val data: Any? = null,
    val error: String? = null
)